function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) =>
/*#__PURE__*/
React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props),
/*#__PURE__*/
React.createElement("path", {
  d: "M1 5c-2 3-1 6 1 9l191 241v164c0 3 1 6 3 7l107 79c3 1 6 2 9 0 3-1 5-4 5-7V255L510 14c2-2 3-6 1-9-1-3-4-5-7-5H9C5 0 2 2 1 5z"
})));